import { Item, MovementDataStore } from "@skinsoft/entity";
import { ReactiveVue } from "@skinsoft/reactive-vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { AddAccessoryForm } from "./add-accessory-form";

@Component({
    components: {
        sAddAccessoryForm: AddAccessoryForm
    },
    props: ['movement', 'noCloseImmediately', 'canChainAdd'],
    template: require('./add-accessory-modal.html')
})
export class AddAccessoryModal extends ReactiveVue {
    public validateItems: Array<Item['id']>
    public noCloseImmediately: boolean
    public canChainAdd: boolean

    public shouldChainAdd: boolean = false

    public mounted = false

    public $movementDataStore: MovementDataStore
    public $refs: {
        modal: any
    }

    public open() {
        this.$refs.modal.show()
    }

    public close() {
        this.$refs.modal.hide()
    }

    public onHide() {
        this.mounted = false
    }

    public onShow() {
        this.mounted = true
    }

    private onAccessorySelected(event) {
        this.$emit('accessory-selected', event)
        if (this.noCloseImmediately && (!this.canChainAdd || !this.shouldChainAdd)) {
            this.$refs.modal.hide()
        }
    }

    @Watch('mounted')
    private onMountedChange(value) {
        this.$emit('mounted', value)
    }
}